import { MESSAGES_COPY } from '../messages/COPY';

export const LINK_URL = {
	MAX: 2048,
	MESSAGE: MESSAGES_COPY.PLEASE_ENTER_URL
};
